// Which columns of an event the browser is allowed to ask for.
//
// `select('*')` is what put this file here. The "public reads approved" policy is
// ROW level: it decides which rows come back and has nothing to say about which
// columns of them do. So a submit-form row carrying somebody's email address in
// `submitted_by` published that address the moment it was approved, to anyone who
// opened the network tab. Today's approved rows only have scrape provenance in
// there ("flourdistrictva.com scrape"), which is why nothing has leaked yet, but
// the pending queue has a real one waiting for a click.
//
// Naming the columns is half the fix and the weaker half, since it is only this
// client being polite. The other half is the grant in
// 20260729201000_revoke_private_event_columns.sql, which takes the private
// columns away from the browser roles so no query can ask for them at all. This
// list has to ship and be live BEFORE that migration lands: a revoke underneath a
// deployed `select('*')` fails the whole query and empties the calendar.
//
// Adding a column to lyh_events? It is private until it is added here, which is
// the right default. The confirmation and admin_notify bookkeeping columns are
// deliberately absent - they are operational state (who was mailed, what Resend
// answered, why a send was skipped) and no card renders them.
//
// Two of these earn their place for a reason that is not "a card shows it":
//   occasions   lib/seasonal reads it for the Featured section, and the approval
//               queue's chips write it. A moderator's word, public by intent.
//   status      every read filters on it, and Postgres checks the privilege on a
//               column a query COMPARES, not only on one it returns.
//
// One literal rather than an array it joins, so the deployed bundle can be
// grepped for it. The sequencing this fix depends on is unverifiable otherwise:
// a marker that only exists after a runtime .join() is not in the file you
// download, and "the column list is live" is exactly the claim that has to hold
// before the revoke lands.
export const PUBLIC_EVENT_COLUMNS =
  'id,name,start_time,end_time,note,venue,host,tags,link,cost_type,price_text,occasions,andrews_pick,status,created_at,session_dates,parent_id'
